// extracted by mini-css-extract-plugin
module.exports = {"news-list":"news-list_news-list__Vh5Zc","title":"news-list_title__2zI3K","divider-wrapper":"news-list_divider-wrapper__V43Ph"};